import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

const LoginButton = ({ onLoginSuccess }) => {
  const { oktaAuth, authState } = useOktaAuth();

  const handleLogin = async () => {
    try {
      await oktaAuth.signInWithRedirect();
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await oktaAuth.signOut();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (!authState) {
    return <div>Loading...</div>;
  }

  if (authState.isAuthenticated) {
    return (
      <div style={{ 
        padding: '20px', 
        border: '1px solid #ddd', 
        borderRadius: '8px',
        marginBottom: '20px',
        backgroundColor: '#f9f9f9'
      }}>
        <div style={{ marginBottom: '10px' }}>
          <strong>Welcome, {authState.idToken?.claims?.name || 'User'}!</strong>
        </div>
        <div style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
          Email: {authState.idToken?.claims?.email}
        </div>
        <button 
          onClick={handleLogout}
          style={{
            padding: '8px 16px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Logout
        </button>
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '20px', 
      border: '1px solid #ddd', 
      borderRadius: '8px',
      marginBottom: '20px',
      textAlign: 'center'
    }}>
      <div style={{ marginBottom: '15px' }}>
        Please log in to access the account selector
      </div>
      <button 
        onClick={handleLogin}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Login with Okta
      </button>
    </div>
  );
};

export default LoginButton;
